import React, { useEffect } from "react";
import { FaTrashAlt } from "react-icons/fa";

const RejectOrderModal = ({
    action,
    setAction,
    showRejectModal,
    setShowRejectModal,
    selectedOrder,
    remark,
    setRemark,
    handleRejectSubmit,
    loading,
    handleDeleteStatus
}) => {

    console.log("first", action)

    const handleClose = () => {
        setShowRejectModal(false);
        setAction("")
    };

    useEffect(() => {
        const esc = (e) => {
            if (e.key === "Escape") handleClose();
        };
        document.addEventListener("keydown", esc);
        return () => document.removeEventListener("keydown", esc);
    }, []);

    if (!showRejectModal) return null;

    return (
        <div className="oms-overlay" onClick={handleClose}>
            <div
                className="oms-modal"
                style={{ maxWidth: 420 }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* HEADER */}
                <div className="oms-modal-head">
                    <span
                        className="oms-modal-title"
                        style={{ color: "var(--red)" }}
                    >
                        {action === "delete" ?
                            <>
                                <FaTrashAlt /> Delete Order
                            </> : "⚠ Cancel Order"}

                    </span>
                    <button className="oms-icon-btn" onClick={handleClose}>
                        ✕
                    </button>
                </div>

                {/* BODY */}
                <div
                    className="oms-modal-body"
                    style={{ paddingTop: 20, paddingBottom: 20 }}
                >
                    <p
                        style={{
                            fontSize: 14,
                            lineHeight: 1.7,
                            color: "var(--text-dim)",
                        }}
                    >
                        {action === "delete" ? "You are about to delete order" : "You are about to cancel order"}{" "}

                        <strong style={{ color: "var(--accent)" }}>
                            {selectedOrder?.trackingId}
                        </strong>{" "}
                        for customer{" "}
                        <strong>{selectedOrder?.customerName}</strong>.
                    </p>

                    <p
                        style={{
                            marginTop: 12,
                            fontSize: 13,
                            color: "var(--text-muted)",
                        }}
                    >
                        Status will be set to{" "}
                        <strong style={{ color: "var(--red)" }}>
                            {action === "delete" ? "Deleted" : "Canceled"}
                            
                        </strong>
                    </p>

                    {/* REMARK INPUT */}
                    <div style={{ marginTop: 14 }}>
                        <input
                            className="oms-form-input"
                            placeholder="Reason / remark (optional)"
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                        />
                    </div>
                </div>

                {/* FOOTER */}
                <div className="oms-modal-foot">
                    <button
                        className="oms-btn oms-btn-ghost"
                        onClick={handleClose}
                    >
                        Keep Order
                    </button>

                    {action === "delete" ? (
                        <button
                            className="oms-btn oms-btn-danger"
                            onClick={handleDeleteStatus}
                            disabled={loading}
                        >
                            {loading ? "Cancelling..." : "Confirm Delete"}
                        </button>
                    ) : (
                        <button
                            className="oms-btn oms-btn-danger"
                            onClick={handleRejectSubmit}
                            disabled={loading}
                        >
                            {loading ? "Cancelling..." : "Confirm Cancel"}
                        </button>
                    )}

                </div>
            </div>
        </div>
    );
};

export default RejectOrderModal;